var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2663",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2663",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAA/BJREFUaEPtmUeIFEEUhnfMgogJEQTPXgRPJkRFMWPOuqaL8SIejAdHBAMoCip4WBXMOYLhoAiCKHjQg5gOgoinPXg0sv6/1Btqa7u6q2qqe9xlG36mt6am633vvap+VVtqamqqa81XqR2gxuFrj0CNA1DX9iJQKpWSnNoVjQegFVBvT6/vRv+y529Su+sLT4sIaACT8ZQhUEdoFDQDugB98TBmJPqOgaJCuADQ0CWGoefxd72H8ezaDboBTY0JkQUwCYM9hHZCB6GfEN92oV5k+l2HplfxjGZ+ywLYjt57IQ5M43nZAPrju7lQT+gl9NgSIT7rKsQ0DHVE5dFZAGX03AXpszkJYCL6MNX6aUbTyGXQrwSQLgpiZrUQMQDo+TfQZ2i19nlIGUcvJ12EuAzNrgYiBsBaGHACGgq91iy9ifth0EALAJs7Q5cgpl5QOsUA2IbB90F8J3zTjD2Ce8J1TwEQiIu4mRcCEQNgPAZ+BG2GDitje6lofMLnuAwAft0J4hxa4AsRA4AGcMLSg7chzgXm9QBoOPTKAUAgzuFmkQ9ELADm8g5oDdQXeg5t8jBeGBmJs9BiV4hYAI5OdurGcuU0tBxizcU5Zr3+RwAaS4hTEAvGVIhQgCd4MGua704+DeukQ1iXWFcALoVibBn3fDvfh+ZAP8Lsc/pVBxWJlbY5kQWwSuXjA2WsCXEP7XwJ5Q3RgDH4lm8RiSwAumkrtB9iVcrlUSCk3YRzcq1nJ9Zix6ANULM54QKgQ5jG1hzCFcAFoog5wUgchTZKJHwACFGGOIHvQvMh2SNI+x20sRyQds9McepOiOPQeqgeANwd/rvS9sT6k23GSjvLiYUFQDzFGD0AwCrYC0CPhGmsQLCUZk2TtJlxcrNDpyvoMwIAg0IAdIhbyuNirEBwA8+aJg8IFo7cDDUAYF0ogA5helwguIHniUZMCL48afxbaCwAKnsQ1zlgRleWUtPj0h4TYhoG5zjvoQlQo+8qZEtNFwim02+H3LZ1Ye3FSFeMZ8dYAHyWzePSfk2lUwhEovGxAXQI09hqIKYoz3+QtNFDFDMC8lybsdLO7edSx3RKNT6PCJgQprECwTWch15p6cQDZS7RiZ6XgfKIQAwInsnyJZlqfJ4RMCFMj0skuJ7zlFuPBI8pWVNlGl8EgD6xXSBoPD3/MWnC6pO3iBTSxyvjD1axPDLhzuqP+vIMPnn68EIZzSLwnavxRUVAQASCx4hModHQSYgHYQTqA7FM3wLpR5RJjq+05TmJkwbmGc8eiAdYvJ5Bs6DGVCtTviwagKYMVt7/ik/usyWdghhSAYKeWMMftb3/E9fQmUFDt/oI/AXEPhq/E8NryQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.6d25fffe5a2202d97c61a63adbdee068.svg";
export { ForwardRef as ReactComponent };